// Client-side identity lookup. The browser Supabase client uses the accessToken
// provider, so supabase.auth.getUser() is unavailable; identity is read from
// /api/auth/user, which validates the HttpOnly session cookie server-side.

export interface AuthUser {
  id: string;
  email: string;
  display_name: string | null;
  user_metadata: Record<string, unknown>;
  /** Geoforge staff, per public.staff. Authoritative checks are server-side; this drives display. */
  is_staff: boolean;
}

/** Fetch the authenticated user, or null when not signed in. */
export async function fetchCurrentUser(): Promise<AuthUser | null> {
  const res = await fetch('/api/auth/user', {
    method: 'GET',
    credentials: 'same-origin',
    cache: 'no-store',
  });

  if (!res.ok) return null;

  const body = (await res.json()) as { user?: AuthUser };
  return body.user ?? null;
}
